export default __webpack_public_path__ + "static/media/AutoScriptModification_1.ed445d13.svg";